module.exports = __webpack_public_path__ + "static/media/close-arrow.23a13033.svg";